import { FormArray, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { EOfferUrlSourceType } from '../../../../core/services/data/data-service.interface';
import { CustomValidators } from '../../../../core/validators/validators';
import { OfferWizardUrlFreeParameterAvailableValuesFormData } from '../interfaces/interfaces';

export const getThirdStepFormGroup = () => {
  return new FormArray([createUrlCardFormGroup(1)]);
};

export const createUrlCardFormGroup = (defaultValue: number, source = EOfferUrlSourceType.OTHER) => {
  const urlValidators = [CustomValidators.url, Validators.required];
  if (source === EOfferUrlSourceType.LD) {
    urlValidators.push(CustomValidators.offerUrl);
  }
  return new FormGroup({
    url: new FormControl(null, urlValidators),
    name: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
    source: new FormControl(source, Validators.required),
    enable_advertiser_external_id: new FormControl(false),
    advertiser_parameter_name: new FormControl('Promotion', [Validators.required, Validators.maxLength(40)]),
    privacy: new FormControl(0),
    default: new FormControl(defaultValue),
    status: new FormControl(1),
    customParameters: new FormArray([]),
  });
};

export const createCustomParameterFormGroup = () => {
  const formGroup = new FormGroup({
    title: new FormControl(null, [Validators.required, Validators.maxLength(40)]),
    type: new FormControl('free'),
    default_value: new FormControl(null),
  }) as FormGroup;
  const optionsArray = createCustomParameterOptionFormGroup(formGroup, true);
  formGroup.addControl('available_values', new FormArray([optionsArray]));
  return formGroup;
};

export const createCustomParameterOptionFormGroup = (formGroup: FormGroup, defaultValue = false) => {
  const valueCtr = new UntypedFormControl(null);
  valueCtr.setValidators([
    Validators.required,
    Validators.maxLength(20),
    // this validator is needed to check if form already has option with same value
    () => {
      const values = formGroup.controls.available_values.value;
      const currentIndex = (formGroup.get('available_values') as FormArray).controls.indexOf(valueCtr.parent);

      const hasDuplicate = values.some(
        (item: OfferWizardUrlFreeParameterAvailableValuesFormData, index: number) => index !== currentIndex && item.value === valueCtr.value
      );

      return hasDuplicate ? { customValidate: $localize`:@@offer_wizard.value_already_exists:Value already exists` } : null;
    },
  ]);
  return new FormGroup({
    // default is needed to determine default_value before sending to backend
    default: new FormControl(defaultValue),
    label: new FormControl(null, [Validators.required, Validators.maxLength(40)]),
    value: valueCtr,
    is_public: new FormControl(true),
  });
};
